import { addDays, startOfDay } from "date-fns";
import { createStaticRanges } from "../../components/TinyDateRangePicker/defaultStaticRange";

export const defaultStaticRanges = createStaticRanges([
  {
    label: "Last 7 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -7));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 14 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -14));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 30 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -30));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 60 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -60));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 90 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -90));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 180 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -180));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
]);
